import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { EnergyStarSubmissionService } from '../../services/energy-star-submission.service';
import * as EnergyStarAccountActions from '../actions/energy-star-account.action';

@Injectable()
export class EnergyStarAccountEffects {
  loadEnergyStarAccounts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EnergyStarAccountActions.loadEnergyStarAccounts),
      mergeMap(() =>
        this.energyStarService.getEnergyStarAccounts().pipe(
          map(response => EnergyStarAccountActions.loadEnergyStarAccountsSuccess({ accounts: response.data })),
          catchError(error => of(EnergyStarAccountActions.loadEnergyStarAccountsFailure({ error }))),
        ),
      ),
    );
  });

  createEnergyStarAccount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EnergyStarAccountActions.createEnergyStarAccount),
      mergeMap(action =>
        this.energyStarService.createEnergyStarAccount(action.request).pipe(
          map(account => EnergyStarAccountActions.createEnergyStarAccountSuccess({ account })),
          catchError(error => {
            let errorMessage = 'An error occurred while creating the Energy Star account.';

            if (error.status === 401) {
              errorMessage = 'Username or password incorrect.';
            } else if (error.status === 403) {
              errorMessage =
                'User does not have permission to access Energy Star. Please enable the account for the live environment in your Energy Star settings.';
            }

            return of(EnergyStarAccountActions.createEnergyStarAccountFailure({ error, errorMessage }));
          }),
        ),
      ),
    );
  });

  reloadAccountsAfterCreate$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EnergyStarAccountActions.createEnergyStarAccountSuccess),
      map(() => EnergyStarAccountActions.loadEnergyStarAccounts()),
    );
  });

  updateEnergyStarAccount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EnergyStarAccountActions.updateEnergyStarAccount),
      mergeMap(action =>
        this.energyStarService.updateEnergyStarAccount(action.id, action.request).pipe(
          map(account => EnergyStarAccountActions.updateEnergyStarAccountSuccess({ account })),
          catchError(error => of(EnergyStarAccountActions.updateEnergyStarAccountFailure({ error }))),
        ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private energyStarService: EnergyStarSubmissionService,
  ) {}
}
